export const setBinBeingEdited = (bin) => {
    return {
        type: "SET_BIN_BEING_EDITED",
        payload: bin
    }
};
